<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-3 shape-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3  text-white">
                  NOTIN
                  <span>Solución Integral</span>
                </h1>
                <p class="lead  text-white">
                  La solución completa para su Notaría
                </p>
                <div class="btn-wrapper">
                  <!-- <p class="lead text-white">
                    This web app can be generated in Vue.js combined with
                    Express / Flask or Laravel. Your choice :)
                  </p> -->
                  <a
                    target="_blank"
                    href="#"
                    class="btn btn-white btn-icon mb-3 mb-sm-0"
                    v-scroll-to="'#contacto'"
                  >
                    <i style="color: red" class="fa fa-rocket"></i>
                    <span class="btn-inner--text"
                      >Solicitar Demo</span
                    >
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
  <div class="profile-page">
    <section class="section section-skew">
      <div class="container">
        <card shadow class="card-profile mt--300" no-body>
          <div class="px-4">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <a href="#">
                    <img
                      v-lazy="'img/sq_notin.png'"
                      class="rounded-circle rounded-notin bg-white"
                    />
                  </a>
                </div>
              </div>
              <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
              
              </div>
              <div class="col-lg-4 order-lg-1">
                <div class="card-profile-stats d-flex justify-content-center">
            
                </div>
              </div>
            </div>
            <div class="row">
                <div class="col-lg-12 text-center mt-5"><br><br><br>
                    <h3>
                        AUMENTA LA EFICIENCIA DE LA NOTARÍA CON LA TECNOLOGÍA NOTIN.
                        
                    </h3>
                  
                </div>
            </div>
            <div class="mt-5 py-5 border-top text-center">
              <div class="row justify-content-center">
                <div class="col-lg-10">
                  <p>
                    Experiencia y fiabilidad en un producto consolidado y con varios hitos distinguibles a lo largo de su evolución. Seguridad en la gestión  integral de su notaría. Visión amplia de sus obligaciones, movimientos, tramitaciones y procesos, junto a los datos normalizados de sus clientes y operaciones documentales.
                  </p>
                  <!-- <a href="#">Show more</a> -->
                </div>
                <div class="row">
                    <div class="col-lg-12 mb-4 px-5">
                      <h3>Funcionalidades</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 mb-4 px-5">
                      <ul class="list-unstyled mt-2">
                          
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-blue text-white"
                              icon="fa fa-book"
                              ></badge>
                              <h6 class="mb-0">Escrituras</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-purple text-white"
                              icon="fa fa-book "
                              ></badge>
                              <h6 class="mb-0">Pólizas</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-indigo text-white"
                              icon="fa fa-book "
                              ></badge>
                              <h6 class="mb-0">Legitimaciones</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-orange text-white"
                              icon="fa fa-folder-open "
                              ></badge>
                              <h6 class="mb-0">Expedientes</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3"
                              icon="fa fa-user"
                              ></badge>
                              <h6 class="mb-0">Clientes</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-pink text-white"
                              icon="fa fa-calendar"
                              ></badge>
                              <h6 class="mb-0">Agenda</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-orange text-white"
                              icon="fa fa-plus "
                              ></badge>
                              <h6 class="mb-0">Y mucho más... </h6>
                          </div>
                          </li>
                      </ul>
                    </div>
                    <div class="col-lg-6">
                      <img class="w100 pt-2 pl-2 pr-2" v-lazy="'img/NotinAcademy_72ppp.png'"/>
                      <h4>NOTIN Academy</h4>
                    </div>
                    <!-- <a href="#">Show more</a> -->
                  </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>
  </div>
    <section class="section section-lg pt-lg-0 ">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
              <h2 class="display-3 text-center">¿Cómo lo hacemos?</h2>
            <div class="row row-grid mt-5">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-check-bold"
                    type="primary"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-primary text-uppercase">Productividad</h6>
                  <p class="description mt-3">
                    Diseñado para agrupar la información en una única vista y evitar el menor número de interacciones para conseguir el resultado deseado.
                  </p>
                  <div>
                    <badge type="primary" rounded>documentación</badge>
                    <badge type="primary" rounded>descargas</badge>
                    <badge type="primary" rounded>texto</badge>
                  </div>
                  <base-button tag="a" href="#" v-scroll-to="'#contacto'" type="primary" class="mt-4">
                    Demostración
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-cloud-upload-96"
                    type="success"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-success text-uppercase">Seguridad</h6>
                  <p class="description mt-3">
                    Múltiples comprobaciones con diferentes criterios y ámbitos se aplican para securizar y normalizar la información introducida.
                  </p>
                  <div>
                    <badge type="success" rounded>seguridad</badge>
                    <badge type="success" rounded>copia</badge>
                    <badge type="success" rounded>online</badge>
                  </div>
                  <base-button tag="a" href="#" v-scroll-to="'#contacto'" type="success" class="mt-4">
                    Demostración
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="ni ni-paper-diploma" type="warning" rounded class="mb-4">
                  </icon>
                  <h6 class="text-warning text-uppercase">Inteligente</h6>
                  <p class="description mt-3">
                    La experiencia del equipo se invierte en adelantar resultados a los usuarios, valores por defecto adaptados al contexto, autollenado de fichas de datos, siempre pensando en la gestión eficaz y rápida de los mismos.
                  </p>
                  <div>
                    <badge type="warning" rounded>visualizar</badge>
                    <badge type="warning" rounded>contenido</badge>
                    <badge type="warning" rounded>imágenes</badge>
                  </div>
                  <base-button tag="a" href="#" v-scroll-to="'#contacto'" type="warning" class="mt-4">
                    demostración
                  </base-button>
                </card>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-12 mt-5">
              <card class=" bg-gradient-success border-0" shadow body-classes="py-5">
                <h4 class="text-center"><b>Valores de adaptación</b></h4>
              <h5 class=" text-center">
                 Detrás del producto hay un equipo que valora las peticiones de los usuarios y trata constantemente de adaptar el producto a las peculiaridades del entorno y a la mejora continua de los procesos para avanzar en eficacia y productividad. Una petición de cambio no es un problema sino una puesta en valor del uso razonado de nuestra herramienta.
              </h5>
              </card>
          </div>
        </div>
      </div>
    </section>
    

   
  </div>
</template>

<script>

export default {
  name: "hash",


};
</script>
<style scoped>

</style>